import Axios from "axios";
var ClientService = (function () {
    function ClientService() {
    }
    ClientService.prototype.getClientList = function (params) {
        return Axios.get("supplierclientapi/customer/list", { params: params });
    };
    ClientService.prototype.getArea = function () {
        return Axios.get("basicapi/customer_area");
    };
    ClientService.prototype.addClient = function (params) {
        return Axios.get("supplierclientapi/customer/add", { params: params });
    };
    ClientService.prototype.editClient = function (params) {
        return Axios.post("supplierclientapi/customer/save", params);
    };
    ClientService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/customer/detail", { params: params });
    };
    ClientService.prototype.getSupplyGoods = function (params) {
        return Axios.get("supplierclientapi/customer/goods_list", { params: params });
    };
    ClientService.prototype.getSupplierShops = function (params) {
        return Axios.get("supplierclientapi/customer/shop_list", { params: params });
    };
    ClientService.prototype.editSupplierShop = function (params) {
        return Axios.post("supplierclientapi/shop/shop_save", params);
    };
    ClientService.prototype.getGroups = function (params) {
        return Axios.get("supplierclientapi/customer/group_list", { params: params });
    };
    ClientService.prototype.addGroup = function (params) {
        return Axios.post("supplierclientapi/customer/save_group", params);
    };
    ClientService.prototype.delGroups = function (params) {
        return Axios.post("supplierclientapi/customer/group_del", params);
    };
    ClientService.prototype.getClientGoods = function (params) {
        return Axios.get("supplierclientapi/suppliergoods/bussiness_goods_list", { params: params });
    };
    ClientService.prototype.getClientsByGroup = function (params) {
        return Axios.get("supplierclientapi/customer/group_childs", { params: params });
    };
    ClientService.prototype.bindGoods = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/do_bind", params);
    };
    ClientService.prototype.unbindGoods = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/un_bind", params);
    };
    ClientService.prototype.changeGroup = function (params) {
        return Axios.post("supplierclientapi/customer/change_group", params);
    };
    ClientService.prototype.getGoodType = function (params) {
        return Axios.get("http://api.scmacewill.cn:3000/apimock/getMockData?id=97", { params: params });
    };
    ClientService.prototype.addCheck = function () {
        return Axios.get("supplierclientapi/customer/add_check");
    };
    ClientService.prototype.changeGroupCustomer = function (params) {
        return Axios.post("supplierclientapi/customer/change_group", params);
    };
    ClientService.prototype.getOperationList = function (params) {
        return Axios.get("api/get_operation_list", params);
    };
    ClientService.prototype.addShop = function (params) {
        return Axios.post("supplierclientapi/shop/shop_add", params);
    };
    ClientService.prototype.addMulShop = function (params) {
        return Axios.post("supplierclientapi/shop/shop_multi_add", params);
    };
    ClientService.prototype.deleteCustomer = function (params) {
        return Axios.post("supplierclientapi/customer/delete", params);
    };
    ClientService.prototype.deleteShop = function (params) {
        return Axios.post("supplierclientapi/shop/delete", params);
    };
    ClientService.prototype.getCustomerFrom = function (params) {
        return Axios.post("api/get_suptobus_from_system_list", params);
    };
    ClientService.prototype.syncShopping = function (params) {
        return Axios.get("supplierclientapi/shop/sync_shopping", { params: params });
    };
    ClientService.prototype.getSaleUser = function (params) {
        return Axios.get("supplierclientapi/account/list", { params: params });
    };
    ClientService.prototype.bindStore = function (params) {
        return Axios.post("supplierclientapi/account_shop/bind_account", params);
    };
    ClientService.prototype.unbindUser = function (params) {
        return Axios.post("supplierclientapi/account_shop/unbind", params);
    };
    ClientService.prototype.getLogistic = function (params) {
        return Axios.get("supplierclientapi/shop/shop_logistics_option", { params: params });
    };
    ClientService.prototype.getLogisticList = function (params) {
        return Axios.get("supplierclientapi/shop/shop_logistics_list", { params: params });
    };
    ClientService.prototype.createLogistics = function (params) {
        return Axios.post("supplierclientapi/shop/shop_logistics_create", params);
    };
    ClientService.prototype.updateLogistics = function (params) {
        return Axios.post("supplierclientapi/shop/shop_logistics_update", params);
    };
    ClientService.prototype.deleteLogistics = function (params) {
        return Axios.post("supplierclientapi/shop/shop_logistics_delete", params);
    };
    ClientService.prototype.getRoute = function (params) {
        return Axios.get("supplierclientapi/route/list", { params: params });
    };
    ClientService.prototype.getRouteList = function (params) {
        return Axios.get("supplierclientapi/route/list", { params: params });
    };
    ClientService.prototype.createRoute = function (params) {
        return Axios.post("supplierclientapi/route/create", params);
    };
    ClientService.prototype.updateRoute = function (params) {
        return Axios.post("supplierclientapi/route/update", params);
    };
    ClientService.prototype.deleteRoute = function (params) {
        return Axios.post("supplierclientapi/route/delete", params);
    };
    ClientService.prototype.getjoinConfig = function (params) {
        return Axios.get("supplierclientapi/supplier_config/franchisee_config", { params: params });
    };
    ClientService.prototype.checkPhoneUsable = function (params) {
        return Axios.get("supplierclientapi/customer/check_reset_phone", { params: params });
    };
    ClientService.prototype.updatePhoneUsable = function (params) {
        return Axios.get("supplierclientapi/customer/reset_business_account", { params: params });
    };
    ClientService.prototype.getCertificate = function (params) {
        return Axios.get("supplierclientapi/customer/certificates", { params: params });
    };
    ClientService.prototype.getClientLevel = function (params) {
        return Axios.post("supplierclientapi/customer/business_level_list", params);
    };
    ClientService.prototype.updateApAccountId = function (params) {
        return Axios.get("supplierclientapi/customer/bind_ap_account", { params: params });
    };
    ClientService.createInstance = function () {
        ClientService.getInstance();
    };
    ClientService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    ClientService.prototype.getHasBusinessCan = function () {
        return Axios.get("supplierclientapi/customer/get_has_business_can");
    };
    ClientService.prototype.freezeShopping = function (params) {
        return Axios.get("supplierclientapi/customer/freeze_shopping", { params: params });
    };
    ClientService.prototype.unfreezeShopping = function (params) {
        return Axios.get("supplierclientapi/customer/unfreeze_shopping", { params: params });
    };
    ClientService.prototype.getShippingFeeList = function (params) {
        return Axios.get("supplierclientapi/customer/shipping_fee_list", { params: params });
    };
    ClientService.prototype.getThirdPartyOptions = function (params) {
        return Axios.get("supplierclientapi/customer/third_party_options", { params: params });
    };
    return ClientService;
}());
export default ClientService;
